import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const appsEndpoint = '/api/some-protected-route';
const authEndpoint = '/api/auth/login';

// Nuevos endpoints para 2FA:
const setupEndpoint = '/api/auth/setup';
const verifySetupEndpoint = '/api/auth/verify-setup';

/**
 * Función login que ahora acepta opcionalmente el parámetro otp.
 * Si el backend responde con twoFactorRequired, se notifica al frontend.
 */

const login = async (username, password, otp = null) => {
  try {
    let token;
    let response;

    try {
      const userAgent = navigator.userAgent;
      // Construimos el payload. Si se envía el otp, se agrega.
      const payload = {
        login: username,
        password,
        user_agent: userAgent,
      };

      if (otp) {
        payload.otp = otp;
      }

      response = await axios.post(`${baseUrl}${authEndpoint}`, payload, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      // Si el backend indica que se requiere OTP, lo devolvemos para que el frontend lo maneje
      if (response.data.twoFactorRequired) {
        return response.data;
      }

      token = response.data.token;
    } catch (loginError) {
      console.error('Error during login:', loginError);
      throw new Error('Login failed');
    }

    try {
      const appsResponse = await axios.get(`${baseUrl}${appsEndpoint}`, {
        headers: {
          'authorization': `Bearer ${token}`
        },
        withCredentials: true
      });
      if (appsResponse.data.message === 'No apps') {
        return { token, applications: [] };
      }
      return { token, applications: appsResponse.data.applications };
    } catch (appsError) {
      console.error('Error fetching applications:', appsError.response?.data || appsError.message);
      if (
        appsError.response &&
        appsError.response.status === 403 &&
        appsError.response.data.message === 'No apps'
      ) {
        throw new Error('No tiene aplicaciones asignadas');
      }
      throw new Error('Fetching applications failed: ' + (appsError.response?.data.message || appsError.message));
    }
  } catch (error) {
    console.error('General error during login process:', error);
    throw error;
  }
};

/**
 * Función para iniciar la configuración de 2FA.
 * Llama al endpoint que genera el secreto y el QR code.
 */
const setupTwoFactor = async () => {
  try {
    const token = localStorage.getItem('token'); // o desde Redux store


    const response = await axios.post(`${baseUrl}${setupEndpoint}`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`  // Agrega el token en el header
      },
      withCredentials: true,
    });


    return response.data; // Debe incluir { qrCodeUrl, message }
  } catch (error) {
    console.error('Error during 2FA setup:', error.response?.data || error.message);
    throw new Error('2FA setup failed');
  }
};


/**
 * Función para verificar la configuración de 2FA.
 * Envía el OTP ingresado al endpoint de verificación.
 */
const verifyTwoFactorSetup = async (otp) => {
  try {
    // Extrae el token desde el almacenamiento (Redux o localStorage) e inclúyelo en el header
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${baseUrl}${verifySetupEndpoint}`,
      { otp },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Envía el token en el encabezado
        },
        withCredentials: true,
      }
    );
    return response.data; // Debe incluir un mensaje de éxito
  } catch (error) {
    console.error('Error during 2FA verification:', error.response?.data || error.message);
    // En lugar de envolver en un Error nuevo, se lanza el error original
    throw error;
  }
};



export { login, setupTwoFactor, verifyTwoFactorSetup };

